<template>
  <div id="app" data-server-rendered="true">
    <yp-navbar ref="navbar" class="no-transparent-navbar"></yp-navbar>
    <page-title-bg first-font="p" title-en="RODUCT CENTER" title-zh="产品中心"></page-title-bg>
    <div class="bread-crumbs-container">
      <div class="container">
        <ol class="breadcrumb">
          <li><a href="/index.html">首页</a></li>
          <li><a href="/product.html">产品中心</a></li>
          <li class="active">产品</li>
        </ol>
      </div>
    </div>
    <section class="enterprise-profile-container">
      <div class="product-class">
        <div
          v-for="(item, index) in productList"
          :key="index"
          :class="mouserindex == index ? 'background-img animate__animated animate__fadeIn' : 'product-class-content'"
          @mouseover="mouserindexEvent(index)"
          @mouseout="mouserOutEvent"
        >
          <div :class="'background-img-box ' + item.className"></div>
          <div v-show="index !== mouserindex">
            <img class="icon-class" :src="item.img" alt="" />
          </div>
          <div v-show="index == mouserindex" class="welfare-content">
            <div class="welfare-content-title">{{ item.title }}</div>
            <div class="welfare-content-text">{{ item.content }}</div>
          </div>
          <div class="welfare-text">{{ item.text }}</div>
        </div>
      </div>
    </section>
    <yp-footer></yp-footer>
  </div>
</template>
<script>
import YpNavbar from '@/components/navbar.vue'
import PageTitleBg from '@/components/page-title-bg.vue'
import YpFooter from '@/components/footer.vue'
export default {
  components: {
    YpNavbar,
    PageTitleBg,
    YpFooter,
  },
  data() {
    return {
      mouserindex: -1,
      productList: [
        {
          img: require('../../../public/static/img/supermarket.png'),
          title: '应用场景',
          content: '各种类型的连锁超市企业的综合管理系统，涵盖经销调存、财务结算等各种模块。',
          className: 'img-supermarket',
          text: '连锁超市管理系统',
        },
        {
          img: require('../../../public/static/img/supplier.png'),
          title: '应用场景',
          content: '针对连锁超市企业的供应商网上管理，涵盖对账、下订单、查询库存等各种模块。',
          className: 'img-supplier',
          text: '连锁超市管理系统',
        },
        {
          img: require('../../../public/static/img/O2O.png'),
          title: '应用场景',
          content: '客流提升，提高增长力，降低成本，顾客离店关联。',
          className: 'img-O2O',
          text: '悦朋微商城-O2O',
        },
        {
          img: require('../../../public/static/img/COM.png'),
          title: '应用场景',
          content: '通过客户标签、建模、画像、自动化营销、人工营销等一系列手段配合，帮助企业更加精准的认识、识别客户，完成营销策略。',
          className: 'img-COM',
          text: 'COM',
        },
        {
          img: require('../../../public/static/img/departmentStore.png'),
          title: '应用场景',
          content: '传统百货企业的综合管理系统，涵盖以合同为中心的百货管理模块。',
          className: 'img-departmentStore',
          text: '百货管理系统',
        },
        {
          img: require('../../../public/static/img/shoppingMall.png'),
          title: '应用场景',
          content: '以商业地产为核心的购物中心模式的综合管理系统，涵盖招商、营运、租赁、物业、财务、数据接口等各种模块。',
          className: 'img-shoppingMall',
          text: '购物中心综合管理系统',
        },
        {
          img: require('../../../public/static/img/Monopoly.png'),
          title: '应用场景',
          content: '',
          className: 'img-Monopoly',
          text: '专营专卖',
        },
        {
          img: require('../../../public/static/img/RF.png'),
          title: '应用场景',
          content: '涵盖以RF枪为载体的收货、盘点等各种模块，支持联网或脱机模式。',
          className: 'img-RF',
          text: 'RF运营管理系统',
        },
        {
          img: require('../../../public/static/img/finance.png'),
          title: '应用场景',
          content: '可以对零售企业的各种软件（如ERP、停车场、物业等）进行财务对接，自动生成符合零售企业要求的各种凭证。',
          className: 'img-finance',
          text: '财务接口平台',
        },
        {
          img: require('../../../public/static/img/resources.png'),
          title: '应用场景',
          content: '专业对零售企业的各种资源（如堆头、端架、广告位等）和资产（如固定资产、低值易耗品等）进行管理的系统。',
          className: 'img-resources',
          text: '资源资产管控平台',
        },
        {
          img: require('../../../public/static/img/medicine.png'),
          title: '应用场景',
          content: '连锁药店的综合管理系统，支持批号和医药GSP管理。',
          className: 'img-medicine',
          text: '零售医药管理系统',
        },
        {
          img: require('../../../public/static/img/pos.png'),
          title: '应用场景',
          content: '与零售企业前台收银系统连接，通过收银小票号，可以随时调用当时的录像视频。',
          className: 'img-pos',
          text: 'POS-DVR系统',
        },
        {
          img: require('../../../public/static/img/monitor.png'),
          title: '应用场景',
          content: '利用手机APP，将门店的运营情况通过视频上传和实时监控进行管理。',
          className: 'img-monitor',
          text: '手机视频监控',
        },
        {
          img: require('../../../public/static/img/invoice.png'),
          title: '应用场景',
          content: '对零售企业的收银机机打发票（小票）进行详细的管理，解决机打发票（小票）的跑冒滴漏现象。',
          className: 'img-invoice',
          text: '发票管理系统',
        },
        {
          img: require('../../../public/static/img/cashier.png'),
          title: '应用场景',
          content: '在安卓平台上开发的，运用在平板电脑上的可移动收银系统，完全替代传统收银机。',
          className: 'img-cashier',
          text: '移动收银系统',
        },
        {
          img: require('../../../public/static/img/secretary.png'),
          title: '应用场景',
          content: '零售企业用户可以在手机上查看销售数据、进行单据审批等功能。',
          className: 'img-secretary',
          text: '手机秘书系统',
        },
        {
          img: require('../../../public/static/img/androidPos.jpg'),
          title: '应用场景',
          content: '与面包店烘焙小程序连接，烘焙商家可通过悦收银进行线下收银、处理小程序订单。',
          className: 'img-android-pos',
          text: '悦小店收银',
        }
      ],
    }
  },
  created() {
    Media($(window).width())
    function Media(width) {
      if (width > 750) {
        refreshRem(1920)
      } else {
        refreshRem(750)
      }
    }
    Media($(window).width())
    // 根据设计图尺寸计算rem
    function refreshRem(designSize) {
      let html = document.documentElement
      let wW = html.clientWidth // 窗口宽度
      let rem = (wW * 100) / designSize
      document.documentElement.style.fontSize = rem + 'px'
    }
  },
  methods: {
    // 鼠标滑动事件
    mouserindexEvent(index) {
      this.mouserindex = index
      console.log('index', index)
    },

    mouserOutEvent() {
      this.mouserindex = -1
    },
  },
}
</script>
<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
